import { GridHelper } from 'components/Grids/GridHelper';
import {
  GeneralCellRenderer,
  NumberCellRenderer,
  BatchFileActionsCellRenderer
} from 'components/Grids/CellRenderers';

export default class BatchFilesColumnDefinitions {
  static createColDefs() {
    const columnDefs = [
      {
        headerName: 'File Name',
        field: 'originalFileName',
        cellRendererFramework: GeneralCellRenderer,
        minWidth: 100,
        width: 200,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Created Date',
        field: 'createdDate',
        cellRendererFramework: GeneralCellRenderer,
        valueGetter: ({
          data: { createdDate }
        }) => GridHelper.dateFormatter(createdDate, 'MMM DD, YYYY HH:mm:ss'),
        minWidth: 95,
        width: 145,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Status',
        field: 'statuString',
        cellRendererFramework: GeneralCellRenderer,
        valueGetter: ({
          data: { status }
        }) => {
          if (status === null || status === 'undefined') {
            return 'N/A';
          }
          return status;
        },
        minWidth: 100,
        width: 150,
        filter: 'text',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Forms',
        field: 'numberOfForms',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: '% Forms Valid',
        field: 'percentageOfValidForms',
        cellClass: 'center-aligned',
        valueGetter: ({
          data: { percentageOfValidForms }
        }) => (percentageOfValidForms !== 'NaN' ? percentageOfValidForms : 'N/A'),
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Form Pages',
        field: 'numberOfFormPages',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Number of Pages',
        field: 'numberOfPages',
        cellClass: 'center-aligned',
        cellRendererFramework: NumberCellRenderer,
        minWidth: 100,
        width: 150,
        filter: 'agNumberColumnFilter',
        filterParams: { apply: true }
      },
      {
        headerName: 'Action',
        cellClass: 'center-aligned form-action-btns',
        field: 'id',
        cellRendererFramework: BatchFileActionsCellRenderer,
        minWidth: 150,
        width: 165,
        filter: false
      }
    ];

    return columnDefs;
  }
}
